export default __webpack_public_path__ + "static/media/3-mobile-popup-image-promo-app.3573a8fc.png";